export default {
  /* This section was auto-generated by bzs-helper ($Properties$) */
  createdOn: { field: 'createdOn', fieldType: 'date' },
  fluidCode: { field: 'fluidCode', fieldType: 'text' },
  fluidId: { field: 'fluidID', fieldType: 'numeric' },
  fluidName: { field: 'fluidName', fieldType: 'text', label: 'Fluid Name' },
  originalFluidName: { field: 'originalFluidName', fieldType: 'text', label: 'Original Fluid Name' },
  fluidSearchField: { field: 'fluidSearchField', fieldType: 'text' },
  fluidTypeCode: { field: 'fluidTypeCode', fieldType: 'text' },
  fluidTypeID: { field: 'fluidTypeID', fieldType: 'numeric' },
  fluidTypeName: { field: 'fluidTypeName', fieldType: 'text' },
  fluidManufacturerID: { field: 'fluidManufacturerID', fieldType: 'numeric' },
  fluidManufacturerName: { field: 'fluidManufacturerName', fieldType: 'text' },
  fluidBrandID: { field: 'fluidBrandID', fieldType: 'numeric' },
  fluidBrandName: { field: 'fluidBrandName', fieldType: 'text' },
  fluidClassID: { field: 'fluidClassID', fieldType: 'numeric' },
  fluidClass: { field: 'fluidClass', fieldType: 'text' },
  fluidWeightID: { field: 'fluidWeightID', fieldType: 'numeric' },
  fluidWeightName: { field: 'fluidWeightName', fieldType: 'text' },
  fluidComments: { field: 'fluidComments', fieldType: 'textarea' },
  fluidKeywords: { field: 'fluidKeywords', fieldType: 'text' },
  fluidBaselineSampleID: { field: 'fluidBaselineSampleID', fieldType: 'numeric' },
  fluidBaselineSampleNumber: { field: 'fluidBaselineSampleNumber', fieldType: 'text' },
  fluidBaselineSampleDate: { field: 'fluidBaselineSampleDate', fieldType: 'text' },
  modifiedOn: { field: 'modifiedOn', fieldType: 'date' },
  isActive: { field: 'isActive', fieldType: 'boolean' }
};
